import React, { useState } from 'react';
import { useFormContext } from '../Provider';
import useValidators from '../Validators/useValidator';
import CommonFieldWrapper from './CommonFieldWrapper';
import { useConditionalHelper } from '../Conditional';
import ButtonRow from '../../Button/ButtonRow';
import Button from '../../Button/Button';
import Modal from '../../Modal';
import { ulid } from 'ulid';
import { useFieldPanelHelper } from '../../Containers/Accordion/Panel';

const fallbackValue = [];

const Repeatable = ({label, form, list, name, help, onChange, disabled, validators, sortItems, addItems = true, deleteItems = true, noItems = "No items", addItem = "Add item"}) => {
    const { formData, updateField, updateValidity, isValidating, isSubmitting, formDisabled } = useFormContext();
    const value = formData[name] ?? fallbackValue;
    const {isValid, error} = useValidators(value, validators, name, updateValidity);
    const [editingItem, setEditingItem] = useState(null);

    useConditionalHelper(name);
    useFieldPanelHelper(name, value, isValid);

    const handleChange = (newVal) => {
        updateField(name, newVal);
        onChange && onChange(newVal);
    }

    const saveItem = async (item) => {
        let updated;
        if (value.some(v => v._id === item._id)) {
            updated = value.map(v => v._id === item._id ? item : v);
        } else {
            updated = [...value, item];
        }
        handleChange(updated);
        setEditingItem(null);
    }

    const isDisabled = formDisabled || disabled || isSubmitting;

    const handleSort = sortItems || ((a, b) => null);

    return <CommonFieldWrapper {...{label, name, help, value, isValid, isValidating, error, validators, isDisabled}}>

        <div>
            <div className="relative flex flex-col divide-y">
                {value.sort(handleSort).map((item, index) => <div key={item._id} className="flex flex-row py-2 align-middle">
                    <div className="grow align-middle">
                        {list(item, index)}
                    </div>
                    <div className="shrink align-middle">
                        <ButtonRow>
                            <Button theme="light" size="md" icon="Pencil" onClick={() => setEditingItem(item)} zeroMargin />
                            {deleteItems && <Button theme="light"
                                size="md"
                                icon="Trash"
                                onClick={() => handleChange(value.filter((v, i) => i !== index))}
                                zeroMargin
                            />}
                        </ButtonRow>
                    </div>
                </div>)}
            </div>

            {value.length === 0 && <div className="text-muted text-center my-2 text-sm">
                {noItems}
            </div>}

            {addItems && <button className="relative block w-full rounded-lg border-2 border-dashed border-gray-300 text-center hover:border-gray-400 focus:outline-none focus:border-brand focus:border-solid fill-brand disabled:fill-gray-500 text-gray-900 disabled:text-gray-500"
                onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    setEditingItem({_id: ulid()});
                }}>
                <span className="my-2 mx-auto block text-sm font-semibold max-w-[75%]">
                    {addItem}
                </span>
            </button>}
        </div>

        <Modal isOpen={!!editingItem} setIsOpen={() => setEditingItem(null)}>
            {form(editingItem, saveItem, () => setEditingItem(null))}
        </Modal>

    </CommonFieldWrapper>
}

export default Repeatable;
